import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import { SvgIcon } from "../../components/SvgComponents";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const KineticTypeOutro: React.FC<OutroProps> = ({
  keywords,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 2) * 0.05;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: "32px",
        padding: "0 40px",
      }}
    >
      {/* CTA Icon */}
      <div
        style={{
          width: "180px",
          height: "180px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#22D3EE",
          borderRadius: "50%",
          boxShadow: "0 0 40px rgba(34, 211, 238, 0.4)",
          transform: `scale(${spring({
            frame,
            fps,
            config: { stiffness: 180, damping: 12 },
          }) * pulseScale})`,
        }}
      >
        <SvgIcon
          name="undraw-social-tree-1-y9wa"
          width={120}
          height={120}
          primaryColor="#050814"
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <h2
          style={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "52px",
            fontWeight: 900,
            color: "white",
            margin: 0,
            textTransform: "uppercase",
            lineHeight: 1,
          }}
        >
          Stay Ahead
        </h2>
        <p
          style={{
            fontFamily: "Inter, sans-serif",
            fontSize: "24px",
            fontWeight: 500,
            color: "#22D3EE",
            margin: 0,
            letterSpacing: "2px",
            textTransform: "uppercase",
          }}
        >
          Follow for more tech
        </p>
      </div>

      {/* Social Handle */}
      <div
        style={{
          marginTop: "20px",
          padding: "16px 32px",
          background: "rgba(255, 255, 255, 0.05)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          borderRadius: "100px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          opacity: interpolate(frame, [15, 30], [0, 1], { extrapolateLeft: "clamp" }),
          transform: `translateY(${interpolate(frame, [15, 30], [20, 0], { extrapolateLeft: "clamp" })}px)`,
        }}
      >
        <span
          style={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "28px",
            fontWeight: 800,
            color: "#BEF264",
          }}
        >
          {keywords?.[0] || "@TechFlow"}
        </span>
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
